import {
    Audio,
    PlayerState,
    Subtitle,
    SubtitlesFontSize,
} from 'store/player/reducer.types';

import { ShowPlayerConfig } from './actions.types';
import {
    DELETE_PLAYER_SUBTITLES_FONT_SIZE,
    DELETE_PROFILE_PLAYER_AUDIO,
    DELETE_PROFILE_PLAYER_SUBTITLES,
    HIDE_PLAYER,
    SET_GENERATE_ID,
    SET_MODAL_PLAYER_FULLSCREEN,
    SET_MUTED,
    SET_PLAYER,
    SET_PLAYER_AUDIO,
    SET_PLAYER_SUBTITLES,
    SET_PLAYER_SUBTITLES_FONT_SIZE,
    SET_SPOTLIGHT_VIDEO_VISIBLE,
    SET_VOLUME,
    SHOW_PLAYER,
} from './constants';

export function showPlayer(config: ShowPlayerConfig) {
    return { type: SHOW_PLAYER, payload: { config } };
}

export function hidePlayer() {
    return { type: HIDE_PLAYER };
}

export function setPlayer(config: ShowPlayerConfig) {
    return { type: SET_PLAYER, payload: { config } };
}

export function setPlayerSubtitles(id: string, subtitles: Subtitle) {
    return { type: SET_PLAYER_SUBTITLES, payload: { id, subtitles } };
}

export function setPlayerAudio(id: string, audio: Audio) {
    return { type: SET_PLAYER_AUDIO, payload: { id, audio } };
}

export function deleteProfilePlayerSubtitles(id: string) {
    return { type: DELETE_PROFILE_PLAYER_SUBTITLES, payload: { id } };
}

export function deleteProfilePlayerAudio(id: string) {
    return { type: DELETE_PROFILE_PLAYER_AUDIO, payload: { id } };
}

export function setPlayerSubtitlesFontSize(
    profileId: string,
    fontSize: SubtitlesFontSize,
) {
    return {
        type: SET_PLAYER_SUBTITLES_FONT_SIZE,
        payload: { profileId, fontSize },
    };
}

export function deletePlayerSubtitlesFontSize(profileId: string) {
    return { type: DELETE_PLAYER_SUBTITLES_FONT_SIZE, payload: { profileId } };
}

export function setShouldUpdateId(
    shouldUpdateId: PlayerState['shouldUpdateId'],
) {
    return { type: SET_GENERATE_ID, payload: { shouldUpdateId } };
}

export function setModalPlayerFullscreen(fullscreen: boolean) {
    return { type: SET_MODAL_PLAYER_FULLSCREEN, payload: { fullscreen } };
}

export function setSpotlightVideoVisible(spotlightVideoVisible: boolean) {
    return {
        type: SET_SPOTLIGHT_VIDEO_VISIBLE,
        payload: { spotlightVideoVisible },
    };
}

export function setMuted(muted?: boolean) {
    return {
        type: SET_MUTED,
        payload: { muted },
    };
}

export function setVolume(volume: number) {
    return { type: SET_VOLUME, payload: { volume } };
}
